import { PAGINATION_PAGE_SIZE } from '@/constants';

export const getPaginationTotalPagesNum = (pagesOrder) => {
  return Math.ceil(pagesOrder.length / PAGINATION_PAGE_SIZE);
};

export const getPaginationPageItemsByPage = (pagesOrder, pageNum) => {
  const res = [];
  if(pagesOrder.length){
    const pageSize = PAGINATION_PAGE_SIZE;
    const paginationOffset = (pageNum - 1) * pageSize;
    for (let i = paginationOffset; i < pagesOrder.length; i++) {
      res.push(pagesOrder[i]);
      if (res.length >= pageSize) {
        break;
      }
    }
  }
  return res;
};
